import { useParams, useLocation } from "react-router-dom";
import { useContext, useEffect } from "react";
import React from "react";
import { useMutation } from "@apollo/client";
import { GetRole, PostDuoLogin } from "graphql/user/user.gql";
import { DispatchContext } from "App";
import { deleteToken, saveToken } from "utils/auth";
import * as httpClient from "http/client";
import client from "graphql/client";
import { useHistory } from "react-router-dom";
import { Loading } from "components/simple";

interface MatchParams {
  savedUserName: string;
  savedState: string;
}

const PostDuoRedirect: React.FC = () => {
  const { savedUserName, savedState } = useParams<MatchParams>();
  const [postDuoLogin] = useMutation(PostDuoLogin);
  const { dispatch } = useContext(DispatchContext);
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const duo_code = searchParams.get("duo_code");
  const state = searchParams.get("state");

  useEffect(() => {
    async function postDuoCallBack(): Promise<void> {
      try {
        const postDuoLoginResponse = await postDuoLogin({
          variables: {
            input: {
              duo_code: duo_code,
              state: state,
              signedState: savedState,
              signedUserName: savedUserName
            }
          }
        });
        if (postDuoLoginResponse.data && postDuoLoginResponse.data.postDuoLogin) {
          const token = postDuoLoginResponse.data.postDuoLogin.token;
          saveToken(token);

          const response = await client.query({ query: GetRole, fetchPolicy: "no-cache" });
          const userRole = response.data.me.role;

          if (userRole === "participant") {
            deleteToken();

            dispatch({ type: "error", description: "You do not have proper permissions" });
          } else {
            // update axios token
            httpClient.default.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            history.push("/assessments");
          }
        }
      } catch (error) {
        dispatch({ type: "error", description: "Failed Duo Authentication" });
        console.log("error", error);
      }
    }
    postDuoCallBack();
  }, [duo_code, postDuoLogin, state]);
  return (
    <>
      <Loading />
    </>
  );
};

export default PostDuoRedirect;
